module.exports = __webpack_public_path__ + "static/media/Applications.fbdb6c63.svg";